import EN_STRINGS from './en.json';
import ES_STRINGS from './es-MX.json';
import FR_STRINGS from './fr-CA.json';

export const legacyStrings = {
  default: EN_STRINGS,
  en: EN_STRINGS,
  es: ES_STRINGS,
  fr: FR_STRINGS,
};
